import { AdditionalDetail } from './additional-detail';

export class RepeatableQuestions{
    questionNumber: string;
    repeats: AdditionalDetail[][];
}